import React from 'react';
import { Box, Grid, Typography, List, ListItem, ListItemIcon, ListItemText, Paper } from '@mui/material';
import {
  AccessTime as ClockIcon,
  Devices as RemoteIcon,
  AttachMoney as MoneyIcon,
  EmojiEvents as BrandIcon,
  Groups as HelpIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';
import SectionContainer from '../shared/SectionContainer';
import LandingCtaButton from '../shared/LandingCtaButton';
import { CTAS, INTERVIEWER_BENEFITS, INTERVIEWER_NETWORK_DESCRIPTION } from '../landingContent';

const BENEFIT_ICONS = [ClockIcon, RemoteIcon, MoneyIcon, BrandIcon, HelpIcon];

const InterviewerNetworkSection = () => (
  <SectionContainer
    id="interviewers"
    title="Join the JobMockAI Interviewer Network"
    titleId="interviewers-heading"
    bgcolor="grey.50"
  >
    <Grid container spacing={4} alignItems="center">
      <Grid item xs={12} md={6}>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
          {INTERVIEWER_NETWORK_DESCRIPTION}
        </Typography>
        <List sx={{ mt: 2 }}>
          {INTERVIEWER_BENEFITS.map((benefit, index) => {
            const Icon = BENEFIT_ICONS[index] || CheckIcon;
            return (
              <ListItem key={benefit} disableGutters sx={{ py: 0.75 }}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Icon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={benefit}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            );
          })}
        </List>
        <Box sx={{ mt: 3 }}>
          <LandingCtaButton
            to={CTAS.interviewer.to}
            label={CTAS.interviewer.label}
            variant={CTAS.interviewer.variant}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            Share your expertise. Earn on your schedule.
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.7 }}>
            Join experienced professionals who conduct mock interviews, mentor candidates,
            and build their reputation while earning additional income.
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  </SectionContainer>
);

export default InterviewerNetworkSection;
